import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Job } from '@data-terminal/shared-models/job';
import { BACKEND_URL, ORGANIZATION_REQUEST_PREFIX } from '@data-terminal/data-access/injection-tokens';

@Injectable({
    providedIn: 'root',
})
export class JobApiService {
    private readonly http = inject(HttpClient);
    private readonly backendUrl = inject(BACKEND_URL);
    private readonly orgRequestPrefix = inject(ORGANIZATION_REQUEST_PREFIX);

    private readonly JOB_LIST_URL = `${this.backendUrl}${this.orgRequestPrefix}joblist`;

    public getJobList(searchQuery: string): Observable<Job[]> {
        return this.http.get<Job[]>(this.JOB_LIST_URL, {
            params: {
                filterJobId: searchQuery,
            },
        });
    }
}
